module.exports = __webpack_public_path__ + "img/04d.8abcf503.png";